/* eslint-disable no-useless-escape */
import React, { useEffect, useRef, useState } from "react";
import "./index.less";
import { Input, Message, Modal, Spin, Tabs } from "@arco-design/web-react";
import TabPane from "@arco-design/web-react/es/Tabs/tab-pane";
import System from "./component/System";
import {
  add,
  add_heart,
  add_user,
  douyin,
  dy_url,
  heart,
  interactive_search,
  plane_w,
} from "@/assets/Inspiration-center";
import HighlightSearch from "@/components/business/HighLightText";
import MySubscription from "./component/MySubscription";
import {
  getScriptReader,
  getUpInfo,
} from "@/services/creativeScript/explosiveScript";
import useData from "./useData";
import { IconToTop } from "@arco-design/web-react/icon";
import _ from "lodash";
interface IUpInfo {
  avatar_url?: string;
  follower_count?: number;
  following_count?: number;
  nickname?: string;
  sec_uid?: string;
  total_favorited?: number;
  unique_id?: string;
}
function formatNumber(num) {
  if (!num) {
    return 0;
  }
  if (num >= 100000000) {
    // 将数字除以100000000，获得亿为单位的数值
    let result = num / 100000000;

    // 保留小数点后两位
    result = Math.floor(result * 10) / 10;

    // 如果小数部分是 .00，则去掉小数
    if (result === Math.floor(result)) {
      result = Math.floor(result);
    }

    return result + "亿";
  } else if (num >= 10000) {
    // 将数字除以10000，获得万为单位的数值
    let result = num / 10000;

    // 保留小数点后两位
    result = Math.floor(result * 10) / 10;

    // 如果小数部分是 .00，则去掉小数
    if (result === Math.floor(result)) {
      result = Math.floor(result);
    }

    return result + "w";
  }

  return num.toString(); // 小于10000的数字直接返回字符串
}
function IndustrySubscribe() {
  const [activeTab, setActiveTab] = useState("system");
  const [searchValue, setSearchValue] = useState("");
  const [getUpLoading, setGetUpLoading] = useState<boolean>(false);
  const [upInfo, setUpInfo] = useState<IUpInfo>({});
  const [isShowModal, setIsShowModal] = useState(false);
  const [scrollTop, setScrollTop] = useState<number>(0);
  const [isShowCollapse, setIsShowCollapse] = useState([]);
  const [isShowBackToTop, setIsShowBackToTop] = useState<boolean>(false);
  const handlePaste = async () => {
    const regex = /user\/[^\?]+/;
    if (!searchValue) {
      setUpInfo({});
      Message.error("抖音主页链接不能为空");
      return;
    }
    // 如果格式符合，则切割并更新输入框内容
    const match = searchValue.match(regex);
    if (match) {
      // 提取 user/ 后面的部分，直到 ?
      setGetUpLoading(true);
      const res = await getUpInfo(match[0].split("/").pop());
      setGetUpLoading(false);
      if (res?.code == 0 && res.data?.item) {
        setUpInfo(res.data.item);
      } else {
        Message.error("获取信息失败");
        setUpInfo({});
      }
    } else {
      Message.error("非正确的抖音主页链接");
      setUpInfo({});
    }
  };
  const backTop = (behavior) => {
    const rootDom = document.querySelector(".industry-subscribe-root");
    rootDom.scrollTo({
      top: 0,
      behavior,
    });
  };
  useEffect(() => {
    const rootDom = document.querySelector(".industry-subscribe-root");

    const toggleVisibility = _.throttle(() => {
      if (isShowBackToTop) return;
      setScrollTop(rootDom.scrollTop);
      if (rootDom.scrollTop > 1000) {
        setIsShowBackToTop(true);
      } else {
        setIsShowBackToTop(false);
      }
    }, 500); // Adjust the throttle delay as needed

    rootDom.addEventListener("scroll", toggleVisibility);

    return () => {
      rootDom.removeEventListener("scroll", toggleVisibility);
    };
  }, []);
  return (
    <div className="industry-subscribe-root">
      <div
        className="backtotop"
        style={{ display: isShowBackToTop ? "flex" : "none" }}
        onClick={() => backTop("smooth")}>
        <IconToTop fontSize={20} />
      </div>
      <Modal
        style={{ width: 720 }}
        title="如何获取视频链接？"
        visible={isShowModal}
        onCancel={() => {
          setIsShowModal(false);
        }}
        footer={null}>
        <div className="get-url-modal">
          <p>
            获取 <p className="text">抖音</p> 账号链接
          </p>
          <img src={dy_url} alt="" />
          {/* <p>
            获取 <p className="text">快手</p> 账号链接
          </p> */}
        </div>
      </Modal>
      <div className="industry-header">
        <div className="header-title">
          <div></div>
          <p>行业订阅观察</p>
          <div></div>
        </div>
        <div className="header-search">
          <div>
            <img
              src={interactive_search}
              width={16}
              alt=""
              style={{ marginRight: 14 }}
            />
            <Input
              style={{ width: 420 }}
              value={searchValue}
              onChange={setSearchValue}
              placeholder="请输入抖音主页链接"
            />
          </div>
          <Spin loading={getUpLoading}>
            <div className="search-btn" onClick={handlePaste}>
              <img src={plane_w} width={18} alt="" style={{ marginRight: 7 }} />
              订阅
            </div>
          </Spin>

          {Object.keys(upInfo).length ? (
            <div className="search-content">
              <HighlightSearch searchTerm={searchValue ? [searchValue] : []}>
                <div>
                  <div className="search-user-box">
                    <img className="img" src={upInfo.avatar_url} alt="" />
                    <img className="search-avatar" src={douyin} alt="" />
                  </div>
                  <div>
                    <h1>{upInfo.nickname}</h1>
                    <p>抖音号: &nbsp;{upInfo.unique_id}</p>
                  </div>
                </div>
              </HighlightSearch>
              <div>
                <img src={heart} alt="" />
                <span>{formatNumber(upInfo.total_favorited)}</span>
              </div>
              <div>
                <img src={add_user} alt="" />
                <span>{formatNumber(upInfo.following_count)}</span>
              </div>
              <div>
                <img src={add_heart} alt="" />
                <span>{formatNumber(upInfo.follower_count)}</span>
              </div>
              <div
                className="subscription-btn"
                onClick={async () => {
                  const { sec_uid, avatar_url } = upInfo;
                  const res = await getScriptReader({
                    nick_name: upInfo.nickname,
                    third_uuid: upInfo.unique_id,
                    sec_uid,
                    avatar_url,
                    platform: 1,
                  });
                  if (res?.code == 0 && res.data.id) {
                    Message.success("订阅成功");
                  } else {
                    Message.error(res);
                  }
                }}>
                <img src={add} alt="" width={16} />
                订阅
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
        <p className="get-url">
          <span>目前仅支持展示时长在2分钟以内的视频内容，超出该时长的视频将不予展示</span>

          <span onClick={() => setIsShowModal(true)}>获取链接？</span>
        </p>
      </div>
      <div className="industry-content">
        <Tabs
          activeTab={activeTab}
          onChange={(e) => {
            setActiveTab(e);
          }}
          className="vlong-tab">
          <TabPane key="system" title="系统推荐"></TabPane>
          <TabPane key="my" title="我的订阅"></TabPane>
        </Tabs>
      </div>
      {activeTab === "system" ? <System /> : <MySubscription />}
    </div>
  );
}

export default IndustrySubscribe;



